module.exports = __webpack_public_path__ + "static/media/CHAP03-PHOTO.38a600fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP03-PHOTO.png
// module id = 305
// module chunks = 0